import http from "@/http/aisea/axios";
const resource = "/enterprises/forms";

const enterpriseFormRepository = {
  /**
   * APIで法人のフォーム一覧を取得する
   * @returns {Promise<Object>}
   * @property {boolean} status - APIのリクエストが成功したかどうか
   * @property {number} code - ステータスコード
   * @property {EnterpriseForm[]} data - データ
   * @property {string} message - メッセージ
   *  @throws {Error}
   */
  index() {
    return http.get(`${resource}`);
  },
};

export default enterpriseFormRepository;
